import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import { numberToCurrency } from '@hc-frontend/utils'
import innerHTML from 'utils/DOM/innerHTML'
import toHtmlClass from './toHtmlClass'
import getById from 'utils/DOM/getById'
import mergeLimitsAndExclusions from './mergeLimitsAndExclusions'

const asMoneyWithoutDecimal = numberToCurrency

function getPreventiveHealth(value) {
  return value === 30
    ? ' at 100% 1 time per coverage period'
    : ', 1-time per policy duration'
}

const renderCoverage =
  (state, expanded = true) =>
  ({ data, plan, templateName }) => {
    if (!data || data.error) {
      return
    }

    const coreBenefits = plan.coreBenefits

    data = JSON.parse(
      JSON.stringify(data)
        .replace('{{Deductible}}', asMoneyWithoutDecimal(+coreBenefits.deductible))
        .replace('{{Coverage}}', asMoneyWithoutDecimal(+coreBenefits.lifetimeMax))
        .replace('{{Coinsurance}}', coreBenefits.userCoinsurance + '%')
        .replace('{{MOOP}}', asMoneyWithoutDecimal(+coreBenefits.outOfPocketMax))
        .replace(
          '{{FamilyMOOP}}',
          asMoneyWithoutDecimal(+coreBenefits.outOfPocketMax * 3)
        )
        .replace(
          '{{PreventiveHealth}}',
          getPreventiveHealth(+coreBenefits.userCoinsurance)
        )
        .replace(
          '{{OutNetworkDeductible}}',
          asMoneyWithoutDecimal(+coreBenefits.outNetworkDeductible)
        )
        .replace(
          '{{OutNetworkCoverage}}',
          asMoneyWithoutDecimal(+coreBenefits.outNetworkLifetimeMax)
        )
    )

    data = mergeLimitsAndExclusions(data)

    const template = Templater(getById(templateName).innerText)
    innerHTML(
      '#coverage__list-main',
      data.plan
        .map(detail => {
          detail.id = detail.headline.toLowerCase().replace(/\W/g, '-')
          detail.show = expanded ? 'show' : ''
          detail.expanded = expanded ? 'true' : 'false'
          return template(detail, { toHtmlClass })
        })
        .join('')
    )

    return data
  }

export default renderCoverage
